// React
import React from 'react';

// Packages

// Utilities
import { getYears } from 'utilities';
import { useLabels } from 'utilities/hooks';
import { CONSTANTS } from 'utilities/configuration';

// Components
import {
    ResultReflections,
    ResultDetails,
    ResultChoice,
    ResultDataCard,
    ResultSetFieldValues,
} from '../_common';
import { ResultsInfluenceOnPolicyDetails } from 'components/_cardContents/resultsInfluenceOnPolicy/resultsInfluenceOnPolicy';

const Name = CONSTANTS.RESULTS.INFLUENCE_ON_POLICY;

const Choice = props => {
    return ResultChoice({
        Name,
        methods: 'Initiative_Result__c.Influence_Type__c',
        fieldName: 'Influence_Type__c',
        ...props,
    });
};

const DataCard = ({ item, theme = 'teal', mode = [] }) => {
    return (
        <ResultDataCard
            {...{
                item,
                theme,
                methodsFieldName: 'Influence_Type__c',
                showDetails: mode.includes('details'),
            }}>
            <ResultsInfluenceOnPolicyDetails {...{ item, theme }} />
        </ResultDataCard>
    );
};
const Details = props => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { object, pickList } = useLabels();

    // ///////////////////
    // METHODS
    // ///////////////////

    function getItemData(formData) {
        const {
            Influence_Type__c,
            Influence_Areas__c,
            Geographical_Reach__c,
            Year__c,
            URL__c,
        } = formData;

        // Data for sf
        return {
            Influence_Type__c,
            Influence_Areas__c,
            Geographical_Reach__c: Geographical_Reach__c[0]?.selectValue,
            Additional_Reach_Info__c: Geographical_Reach__c[0]?.textValue,
            Year__c: Year__c?.length > 0 ? Year__c : null,
            URL__c,
        };
    }

    // ///////////////////
    // FIELDS
    // ///////////////////

    function fields() {
        return [
            {
                type: 'Select',
                name: 'Influence_Areas__c',
                object: object.config(
                    'Initiative_Result__c.Influence_Areas__c'
                ),
                options: pickList('Initiative_Result__c.Influence_Areas__c'),
            },
            {
                type: 'SelectList',
                name: 'Geographical_Reach__c',
                object: object.config(
                    'Initiative_Result__c.Geographical_Reach__c'
                ),
                options: pickList('Initiative_Result__c.Geographical_Reach__c'),
                sort: false,
                showText: true,
                listMaxLength: 1,
            },
            {
                type: 'Select',
                name: 'Year__c',
                object: object.config(
                    'Initiative_Result__c.Year__c___Influence_On_Policy'
                ),
                options: getYears(),
            },
            {
                type: 'Text',
                name: 'URL__c',
                object: object.config(
                    'Initiative_Result__c.URL__c___Influence_On_Policy'
                ),
                maxLength: 80,
            },
        ];
    }

    // ///////////////////
    // RETURN
    // ///////////////////

    return ResultDetails({
        fields,
        fieldSuffix: '___Influence_On_Policy',
        getItemData,
        ...props,
    });
};

const Reflections = props => {
    return ResultReflections({
        ...props,
    });
};

const setFieldValues = ({ choice, form, id, utilities, REPORT_ID }) => {
    // ///////////////////
    // DETAILS
    // ///////////////////

    const {
        Influence_Type__c,
        Influence_Areas__c,
        Geographical_Reach__c,
        Year__c,
        Additional_Reach_Info__c,
        URL__c,
    } = utilities.results.get(id);

    // Choice
    form.setValue('Influence_Type__c', Influence_Type__c);

    form.setValue('Influence_Areas__c', Influence_Areas__c);
    form.setValue('Geographical_Reach__c', [
        {
            selectValue: Geographical_Reach__c,
            textValue: Additional_Reach_Info__c,
        },
    ]);
    form.setValue('Year__c', Year__c);
    form.setValue('URL__c', URL__c);

    // ///////////////////
    // ALL THE OTHER STUFF
    // ///////////////////

    ResultSetFieldValues({
        choice,
        form,
        id,
        utilities,
        REPORT_ID,
    });
};

export { Name, DataCard, Choice, Details, Reflections, setFieldValues };
